var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimesCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "times-circle",
    d: "M15,8a7,7,0,1,0,7,7A7,7,0,0,0,15,8Zm0,13.1A6.1,6.1,0,1,1,21.1,15,6.1,6.1,0,0,1,15,21.1Zm2.676-8.053L15.72,15l1.956,1.956a.339.339,0,0,1,0,.48l-.24.24a.339.339,0,0,1-.48,0L15,15.72l-1.956,1.956a.339.339,0,0,1-.48,0l-.24-.24a.339.339,0,0,1,0-.48L14.28,15l-1.956-1.956a.339.339,0,0,1,0-.48l.24-.24a.339.339,0,0,1,.48,0L15,14.28l1.956-1.956a.339.339,0,0,1,.48,0l.24.24A.344.344,0,0,1,17.676,13.044Z",
    transform: "translate(-8 -8)",
    fill: "#888"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimesCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/times-circle.cd025191d4a1e06251395de60363f1b2.svg";